import React, { memo } from 'react';
import { MessageTypeRegistration } from './types';

interface RegistryRowProps<TItem> {
  registration: MessageTypeRegistration<TItem>;
  item: TItem;
}

const RegistryRowInner = <TItem,>({
  registration,
  item,
}: RegistryRowProps<TItem>): React.JSX.Element => <registration.Row item={item} />;

function areEqual<TItem>(
  prev: RegistryRowProps<TItem>,
  next: RegistryRowProps<TItem>,
): boolean {
  return (
    prev.registration.id === next.registration.id && Object.is(prev.item, next.item)
  );
}

export const RegistryRow = memo(RegistryRowInner, areEqual) as <TItem>(
  props: RegistryRowProps<TItem>,
) => React.JSX.Element;
